export enum ThousandSeparatorMode {
    DEFAULT = 'DEFAULT', DECIMAL_MANDATORY = 'DECIMAL_MANDATORY', DECIMAL_OPTIONAL = 'DECIMAL_OPTIONAL'
}
